import { Col, DatePicker, Row, TimePicker } from 'antd';
import { Button } from 'components/Button/Button';
import moment, { Moment } from 'moment';
import { VFC } from 'react';
import styled from 'styled-components';
import { FormattedMessage, useIntl } from 'react-intl';
import { DateTime as messages } from '../messages';

const StyledContainer = styled.div`
  .ant-picker-footer {
    height: 50px;

    button {
      height: 100%;
    }
  }
`;

interface DateTimeProps {
  value?: Moment;
  onChange?: (value: Moment | null) => void;
}

export const DateTime: VFC<DateTimeProps> = ({ value, onChange }) => {
  const intl = useIntl();

  const handleChange = (update: Moment | null, type: 'time' | 'date') => {
    if (!onChange) return;

    if (type === 'date' && update) {
      onChange(moment(value).year(update.year()).month(update.month()).date(update.date()));
    } else if (type === 'time' && update) {
      onChange(moment(value).hour(update.hour()).minute(update.minute()).second(0));
    }
  };

  const handleNow = () => {
    if (!onChange) return;

    onChange(moment().second(0));
  };

  const timePickerPanelRenderer = (originalPanel: React.ReactNode) => (
    <StyledContainer>{originalPanel}</StyledContainer>
  );

  return (
    <Row className="w-100" gutter={8} justify="space-between">
      <Col span={11}>
        <DatePicker
          allowClear={false}
          className="w-100"
          format="DD.MM.YYYY"
          placeholder={intl.formatMessage(messages.date)}
          value={value}
          onChange={update => handleChange(update, 'date')}
        />
      </Col>
      <Col span={7}>
        <TimePicker
          allowClear={false}
          className="w-100"
          format="HH:mm"
          panelRender={timePickerPanelRenderer}
          placeholder={intl.formatMessage(messages.time)}
          showSecond={false}
          value={value}
          onChange={update => handleChange(update, 'time')}
        />
      </Col>
      <Col span={6}>
        <Button block style={{ height: 'auto' }} type="primary" onClick={handleNow}>
          <FormattedMessage {...messages.now} />
        </Button>
      </Col>
    </Row>
  );
};
